// src/locales/pt.js
// VEGA ROBOTICS - Traduções em Português (Brasil)

export default {
  // ============================================================
  // GERAL
  // ============================================================
  general: {
    company: 'Vega Robotics',
    tagline: 'Inteligência Artificial para Indústria',
    learnMore: 'Saiba mais',
    contactUs: 'Fale Conosco',
    getStarted: 'Começar Agora',
    readMore: 'Ler Mais',
    viewAll: 'Ver Todos',
    loading: 'Carregando...',
    error: 'Ocorreu um erro',
    success: 'Sucesso!',
    send: 'Enviar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    close: 'Fechar',
    search: 'Buscar',
    filter: 'Filtrar',
    sortBy: 'Ordenar por',
    all: 'Todos',
    none: 'Nenhum',
    yes: 'Sim',
    no: 'Não',
    scheduleDemo: 'Agende uma Demo',
    scheduleMeeting: 'Agendar Reunião',
    requestQuote: 'Solicitar Orçamento',
  },

  // ============================================================
  // HEADER / NAVEGAÇÃO
  // ============================================================
  nav: {
    home: 'Início',
    about: 'Sobre',
    solutions: 'Soluções',
    testimonials: 'Depoimentos',
    blog: 'Blog',
    contact: 'Contato',
    investors: 'Investidores',
    careers: 'Carreiras',
    products: 'Produtos',
    services: 'Serviços',
    partners: 'Parceiros',
  },

  // ============================================================
  // HERO SECTION
  // ============================================================
  hero: {
    eyebrow: 'Tecnologia brasileira para a indústria global',
    titleStatic: 'Soluções para quem',
    title: 'Visão Computacional para Indústria 4.0',
    subtitle: 'Transforme sua linha de produção com inteligência artificial. Detecte defeitos em tempo real e aumente a qualidade.',
    button: 'Conheça nossas Soluções',
    cta: 'Agende uma Demo',
    ctaSecondary: 'Conheça Nossas Soluções',
    trusted: 'Confiado por empresas líderes',
    verbs: [
      'transforma',
      'automatiza',
      'produz',
      'monta',
      'estampa',
      'organiza',
      'controla',
      'entrega',
    ],
  },

  // ============================================================
  // SOLUÇÕES
  // ============================================================
  solutions: {
    title: 'Nossas soluções',
    subtitle: 'Tecnologia de ponta para transformar sua operação industrial',
    
    engenhariaAplicada: {
      name: 'Engenharia Aplicada',
      description: 'Projetos sob demanda para sua operação industrial',
    },
    automacaoIndustrial: {
      name: 'Automação Industrial',
      description: 'Células e sistemas que aumentam produtividade e precisão',
    },
    qualidadeInteligente: {
      name: 'Qualidade Inteligente',
      description: 'Inspeção visual com IA para zero defeitos',
    },
    agentesIndustriais: {
      name: 'Agentes Industriais',
      description: 'IA generativa aplicada aos seus processos',
    },
    
    vixem: {
      name: 'VIXEM',
      tagline: 'Visão Computacional Edge',
      description: 'Sistema de inspeção visual com IA embarcada para detecção de defeitos em tempo real na linha de produção.',
      features: [
        'Detecção de defeitos em milissegundos',
        'Funciona offline (edge computing)',
        'Integração com sistemas MES/ERP',
        'Dashboard de qualidade em tempo real',
      ],
    },
    
    cadpro: {
      name: 'CADPro',
      tagline: 'Serviços de Engenharia',
      description: 'Projetos de ferramentais, dispositivos e automação industrial com engenharia de alta precisão.',
      features: [
        'Projeto de estampos e matrizes',
        'Dispositivos de controle',
        'Automação de processos',
        'Consultoria técnica especializada',
      ],
    },
    
    proagentes: {
      name: 'PROAgentes.ai',
      tagline: 'Agentes de IA',
      description: 'Plataforma de agentes inteligentes para automação de processos empresariais e atendimento.',
      features: [
        'Agentes conversacionais',
        'Automação de tarefas',
        'Integração com sistemas',
        'Análise de dados inteligente',
      ],
    },
  },

  // ============================================================
  // DEPOIMENTOS
  // ============================================================
  testimonials: {
    title: 'O que dizem sobre nós',
    subtitle: 'Veja como estamos transformando a indústria brasileira',
    prev: 'Anterior',
    next: 'Próximo',
    goToSlide: 'Ir para slide',
    
    items: [
      {
        text: 'Profissionais da mais alta qualidade! Atendimento ímpar.',
        author: 'Rodrigo',
      },
      {
        text: 'Empresa de ponta em automação e robótica. O trabalho de alta qualidade, e a equipe demonstra grande competência técnica. Recomendo a quem busca inovação e parceiros confiáveis no setor de tecnologia.',
        author: 'Anderson Fernandes',
      },
      {
        text: 'Excelente empresa. Possui ótimo atendimento e confiabilidade.',
        author: 'Danilo Carvalho Souza',
      },
      {
        text: 'Recomendo fortemente esta empresa para quem busca inovação, qualidade em visão computacional e IA. A Vega Robotics entrega soluções de ponta para a indústria com compromisso com excelência.',
        author: 'Sttela Bastos',
      },
    ],
  },

  // ============================================================
  // CTA
  // ============================================================
  cta: {
    title: 'Pronto para transformar sua indústria?',
    subtitle: 'Fale com nossos especialistas.',
  },

  // ============================================================
  // BLOG
  // ============================================================
  blog: {
    title: 'Conteúdo que transforma',
    subtitle: 'Artigos, cases e novidades sobre IA, automação e indústria 4.0',
    readTime: 'min de leitura',
    viewAll: 'Ver todos os artigos',
    noPosts: 'Nenhum artigo encontrado.',
    loadMore: 'Carregar Mais',

    // Página do Blog
    pageTitle: 'Blog Vega Robotics',
    pageSubtitle: 'Artigos sobre tecnologia, inovação, inteligência artificial e o futuro da indústria brasileira.',
    allCategories: 'Todos',
    noPostsTitle: 'Nenhum post encontrado',
    noPostsText: 'Em breve teremos novidades por aqui!',
    noPostsCategory: 'Não há posts nesta categoria ainda.',
    readMore: 'Ler mais',
    views: 'views',
    backToBlog: 'Voltar ao Blog',
    share: 'Compartilhar',

    categories: {
      all: 'Todos',
      computerVision: 'Visão Computacional',
      edgeComputing: 'Edge Computing',
      ai: 'Inteligência Artificial',
      industry: 'Indústria 4.0',
      vision: 'Visão Computacional',
      automation: 'Automação',
      news: 'Notícias',
      tecnologia: 'Tecnologia',
      industria: 'Indústria 4.0',
      ia: 'Inteligência Artificial',
      inovacao: 'Inovação',
      cases: 'Cases de Sucesso',
      tutoriais: 'Tutoriais',
    },

    posts: [
      {
        title: 'Como a Visão Computacional está transformando a qualidade industrial',
        excerpt: 'Descubra como sistemas de IA estão detectando defeitos invisíveis ao olho humano e reduzindo perdas em até 40%.',
        date: '04 de dez. de 2024',
      },
      {
        title: 'Edge Computing na Indústria: Por que processar dados na borda?',
        excerpt: 'Entenda as vantagens de processar dados localmente e como isso impacta latência, segurança e custos operacionais.',
        date: '27 de nov. de 2024',
      },
      {
        title: 'Sistemas Multiagentes: O futuro da automação inteligente',
        excerpt: 'Como agentes de IA colaborativos estão revolucionando processos industriais e tomando decisões em tempo real.',
        date: '19 de nov. de 2024',
      },
    ],
  },

  // ============================================================
  // FORMULÁRIO DE CONTATO (Modal HubSpot)
  // ============================================================
  contactForm: {
    title: 'Solicitar',
    titleHighlight: 'Orçamento',
    name: 'Nome',
    namePlaceholder: 'Seu nome completo',
    email: 'E-mail',
    emailPlaceholder: 'seu@email.com',
    phone: 'Telefone',
    phonePlaceholder: '(11) 99999-9999',
    company: 'Empresa',
    companyPlaceholder: 'Nome da empresa (opcional)',
    message: 'Descreva seu projeto',
    messagePlaceholder: 'Conte um pouco sobre o projeto que precisa desenvolver...',
    submit: 'Enviar Solicitação',
    sending: 'Enviando...',
    successTitle: 'Mensagem Enviada!',
    successText: 'Recebemos sua solicitação e entraremos em contato em até 24 horas úteis.',
    errorRequired: 'Por favor, preencha todos os campos obrigatórios.',
    errorGeneral: 'Ocorreu um erro ao enviar. Tente novamente ou entre em contato pelo WhatsApp.',
    privacy: 'Ao enviar, você concorda com nossa política de privacidade. Seus dados estão seguros e não serão compartilhados.',
  },

  // ============================================================
  // CONTATO
  // ============================================================
  contact: {
    title: 'Entre em Contato',
    subtitle: 'Estamos prontos para ajudar sua empresa a evoluir',
    
    form: {
      name: 'Nome completo',
      namePlaceholder: 'Seu nome',
      email: 'E-mail',
      emailPlaceholder: 'seu@email.com',
      phone: 'Telefone',
      phonePlaceholder: '(11) 99999-9999',
      company: 'Empresa',
      companyPlaceholder: 'Nome da sua empresa',
      subject: 'Assunto',
      subjectPlaceholder: 'Como podemos ajudar?',
      message: 'Mensagem',
      messagePlaceholder: 'Descreva sua necessidade...',
      submit: 'Enviar Mensagem',
      sending: 'Enviando...',
      successMessage: 'Mensagem enviada com sucesso! Retornaremos em breve.',
      errorMessage: 'Erro ao enviar mensagem. Tente novamente.',
    },
    
    info: {
      address: 'Endereço',
      addressValue: 'São Paulo, SP - Brasil',
      email: 'E-mail',
      emailValue: 'contato@vegarobotics.com.br',
      phone: 'Telefone',
      phoneValue: '+55 (11) 99999-9999',
      hours: 'Horário',
      hoursValue: 'Seg - Sex: 9h às 18h',
    },
  },

  // ============================================================
  // FOOTER
  // ============================================================
  footer: {
    description: 'Inteligência artificial para a indústria brasileira. Visão computacional, sistemas multiagentes e edge computing.',
    solutions: 'Soluções',
    contact: 'Contato',
    copyright: '© {year} Vega Robotics. Todos os direitos reservados.',
    privacy: 'Privacidade',
    terms: 'Termos de Uso',
    
    links: {
      title: 'Links Rápidos',
      solutions: 'Soluções',
      contact: 'Contato',
      privacy: 'Privacidade',
      terms: 'Termos de Uso',
    },
    
    social: {
      title: 'Redes Sociais',
      followUs: 'Siga-nos',
    },
  },

  // ============================================================
  // PÁGINAS DE ERRO
  // ============================================================
  errors: {
    notFound: {
      title: 'Página Não Encontrada',
      description: 'A página que você está procurando não existe ou foi movida.',
      backHome: 'Voltar ao Início',
    },
    serverError: {
      title: 'Erro no Servidor',
      description: 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
      retry: 'Tentar Novamente',
    },
  },

  // ============================================================
  // VALIDAÇÕES DE FORMULÁRIO
  // ============================================================
  validation: {
    required: 'Este campo é obrigatório',
    email: 'Digite um e-mail válido',
    phone: 'Digite um telefone válido',
    minLength: 'Mínimo de {min} caracteres',
    maxLength: 'Máximo de {max} caracteres',
  },

  // ============================================================
  // ACESSIBILIDADE
  // ============================================================
  accessibility: {
    skipToContent: 'Pular para o conteúdo',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    toggleLanguage: 'Alterar idioma',
    darkMode: 'Modo escuro',
    lightMode: 'Modo claro',
    backToTop: 'Voltar ao topo',
    play: 'Play',
    pause: 'Pausar',
    clientsAriaLabel: 'Empresas que confiam na Vega',
    whatsappAriaLabel: 'Falar no WhatsApp',
  },

  // ============================================================
  // CARREIRAS
  // ============================================================
  careers: {
    pageTitle: 'Trabalhe Conosco',
    pageSubtitle: 'Junte-se a uma equipe apaixonada por tecnologia e inovação. Construa o futuro da indústria brasileira.',
    openPositions: 'Vagas Abertas',
    departments: 'Departamentos',
    searchPlaceholder: 'Buscar vagas...',
    allDepartments: 'Todos os Departamentos',
    allModalities: 'Todas as Modalidades',
    viewJob: 'Ver Vaga',
    applyNow: 'Candidate-se',
    backToJobs: 'Voltar às Vagas',
    aboutRole: 'Sobre a Vaga',
    requirements: 'Requisitos',
    benefits: 'Benefícios',
    share: 'Compartilhar',
    noJobsTitle: 'Nenhuma vaga encontrada',
    noJobsText: 'No momento não temos vagas abertas. Siga-nos nas redes sociais para ficar por dentro das novidades.',
    noJobsFiltered: 'Nenhuma vaga corresponde aos filtros selecionados.',
    notFoundTitle: 'Vaga não encontrada',
    notFoundText: 'A vaga que você está procurando não existe ou foi encerrada.',

    types: {
      fullTime: 'Tempo Integral',
      partTime: 'Meio Período',
      contract: 'Contrato',
      internship: 'Estágio',
      freelance: 'Freelance',
    },

    modalities: {
      onSite: 'Presencial',
      remote: 'Remoto',
      hybrid: 'Híbrido',
    },

    experience: {
      intern: 'Estágio',
      junior: 'Júnior',
      mid: 'Pleno',
      senior: 'Sênior',
      lead: 'Líder/Gerente',
    },

    form: {
      name: 'Nome Completo',
      namePlaceholder: 'Seu nome',
      email: 'E-mail',
      emailPlaceholder: 'seu@email.com',
      phone: 'Telefone',
      phonePlaceholder: '(11) 99999-9999',
      linkedin: 'LinkedIn',
      portfolio: 'Portfolio / GitHub',
      coverLetter: 'Carta de Apresentação',
      coverLetterPlaceholder: 'Conte um pouco sobre você e por que você é o candidato ideal para esta vaga...',
      submit: 'Enviar Candidatura',
      sending: 'Enviando...',
      successTitle: 'Candidatura Enviada!',
      successMessage: 'Recebemos sua candidatura e entraremos em contato em breve.',
      errorMessage: 'Ocorreu um erro ao enviar. Tente novamente.',
    },
  },

  // ============================================================
  // WHATSAPP
  // ============================================================
  whatsapp: {
    defaultMessage: 'Olá! Gostaria de saber mais sobre as soluções da Vega Robotics.',
  },
};
